import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Button from '../../global/ui/Button';
import OtpInput from '../OtpInput/OtpInput';
import { verifyAgentOtp } from '../../api/bookingAgent';
import { AgentHandoffState, buildEmbedReturnUrl, getAgentHandoffFromLocation, setAgentResume } from '../../utils/agentSessionStorage';
import { getURLstylistCode } from '../../utils/globalFunctions';
import { showToast } from '../../utils';
import { images } from '../../utils/constants/assets';
import { ROUTES_CONSTANTS } from '../../utils/constants/routesString';
import { STRING_CONSTANTS } from '../../utils/constants/stringConstants';
import useStore from '../../zustandstore';

export default function AgentVerifyOtp() {
  const navigate = useNavigate();
  const location = useLocation();
  const handoff = getAgentHandoffFromLocation(location.search, location.state as AgentHandoffState);
  const stylistCode = getURLstylistCode();
  const stylistLocationData = useStore((state: any) => state.stylistLocationData);

  const [otp, setOtp] = useState('');
  const [loading, setLoading] = useState(false);
  const [resendOtp, setResendOtp] = useState(false);
  const [secs, setSecs] = useState(60);

  const stylistName = stylistLocationData?.stylist_info?.full_name || 'your stylist';

  useEffect(() => {
    if (!handoff.sessionId || !handoff.token || !handoff.mobile) {
      navigate(`${ROUTES_CONSTANTS.index}${stylistCode}`);
    }
  }, [handoff, navigate, stylistCode]);

  useEffect(() => {
    const timerId = setInterval(() => {
      setSecs((current) => {
        if (current <= 1) {
          setResendOtp(true);
          return 0;
        }
        return current - 1;
      });
    }, 1000);
    return () => clearInterval(timerId);
  }, []);

  const handleBack = () => {
    navigate(`${ROUTES_CONSTANTS.index}${stylistCode}`);
  };

  const handleVerify = async () => {
    if (otp.length !== 6) {
      showToast(STRING_CONSTANTS.enter_valid_otp, 'error');
      return;
    }
    setLoading(true);
    try {
      const result = await verifyAgentOtp(
        handoff.sessionId,
        handoff.mobile as string,
        otp,
        handoff.token as string,
      );
      if (!result.verified) {
        showToast('Verification failed. Please try again.', 'error');
        return;
      }
      const resumeMessage = result.is_new_client
        ? 'OTP verified. I am a new client.'
        : 'OTP verified.';
      const returnUrl = new URLSearchParams(location.search).get('return_url');
      if (returnUrl) {
        window.location.href = buildEmbedReturnUrl(returnUrl, handoff.sessionId, resumeMessage);
        return;
      }
      setAgentResume({
        sessionId: handoff.sessionId,
        message: resumeMessage,
        openChat: true,
      });
      navigate(`${ROUTES_CONSTANTS.index}${stylistCode}`);
    } catch {
      showToast('Verification failed. Please try again.', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="booking-wrapper">
      <div className="step_5 sign_up_screen otp_screen">
        <div className="upper-wrapper">
          <div className="back-logo">
            <div className="go-back" onClick={handleBack}>
              <img src={images.go_back} alt="" />
            </div>
          </div>

          <h1>Verify your number</h1>
          <p>
            {STRING_CONSTANTS.enter_otp} {stylistName}.
          </p>

          <p className="verification_number">
            {`Verify your number, we've sent a one time code to your mobile number: ${handoff.mobile}`}
          </p>

          <div className="otp_number">
            <OtpInput value={otp} valueLength={6} onChange={setOtp} />
            <p className="resend_msg">
              Didn&apos;t receive a code?{' '}
              {resendOtp ? (
                <span>Check your messages and try again.</span>
              ) : (
                <b>Resend in {secs} secs</b>
              )}
            </p>
          </div>
        </div>

        <div className="bottom-wrapper">
          <Button
            className="continue-btn"
            type="button"
            btnTxt="Continue"
            isLoading={loading}
            onClick={handleVerify}
          />
        </div>
      </div>
    </div>
  );
}
